export default __webpack_public_path__ + "static/media/PROCESSMETHOD_CNC_DRILLING.0a3512df.png";